module.exports = __webpack_public_path__ + "images/9ff2af01648a5f609c64fd8e5cad5cc8-classroom1.jpg";